import type { DraftDetail } from "./types"

export function ReviewStatusBadge({ confidence }: { confidence: DraftDetail["confidence"] }) {
  const map = {
    high: { label: "Draft bereit", bg: "#dcfce7", color: "#166534", border: "#86efac" },
    medium: { label: "Pruefen", bg: "#fef3c7", color: "#854F0B", border: "#fcd34d" },
    low: { label: "Rueckfrage noetig", bg: "#fee2e2", color: "#991b1b", border: "#fca5a5" },
  }[confidence]
  return (
    <span style={{
      background: map.bg, color: map.color, border: `1px solid ${map.border}`,
      padding: "3px 10px", borderRadius: 999, fontSize: 12, fontWeight: 500, whiteSpace: "nowrap",
    }}>
      {map.label}
    </span>
  )
}
